import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteTypeTransactionApi } from "../../services/type-transaction/delete.type.transaction.api";

export const useDeleteTypeTransactionApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => deleteTypeTransactionApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["type-transaction"],
      });
    },
  });
};
